import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KakobuySpreadsheetPolska from "../pages/kakobuy-spreadsheet-polska/page";
import BestKakobuySpreadsheet2026 from "../pages/best-kakobuy-spreadsheet-2026/page";
import ArticleKakobuySpreadsheetPolska2026 from "../pages/artykul/kakobuy-spreadsheet-polska-2026/page";
import NajlepszyKakobuySpreadsheet from "../pages/artykul/najlepszy-kakobuy-spreadsheet/page";
import KakobuySpreadsheetPolskaRanking from "../pages/artykul/kakobuy-spreadsheet-polska-ranking/page";
import ListaProduktowKakobuy from "../pages/artykul/lista-produktow-kakobuy/page";
import KakobuySpreadsheetLinki from "../pages/artykul/kakobuy-spreadsheet-linki/page";
import KakobuyFindsPolska from "../pages/artykul/kakobuy-finds-polska/page";
import KakobuySneakersSpreadsheet from "../pages/artykul/kakobuy-sneakers-spreadsheet/page";
import KakobuyClothingSpreadsheet from "../pages/artykul/kakobuy-clothing-spreadsheet/page";
import NowyKakobuySpreadsheet from "../pages/artykul/nowy-kakobuy-spreadsheet-2026/page";
import BudgetSpreadsheetKakobuy from "../pages/artykul/budget-spreadsheet-kakobuy/page";
import LuxurySpreadsheetKakobuy from "../pages/artykul/luxury-spreadsheet-kakobuy/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/kakobuy-spreadsheet-polska/", element: <KakobuySpreadsheetPolska /> },
  { path: "/best-kakobuy-spreadsheet-2026/", element: <BestKakobuySpreadsheet2026 /> },
  { path: "/artykul/kakobuy-spreadsheet-polska-2026/", element: <ArticleKakobuySpreadsheetPolska2026 /> },
  { path: "/artykul/najlepszy-kakobuy-spreadsheet/", element: <NajlepszyKakobuySpreadsheet /> },
  { path: "/artykul/kakobuy-spreadsheet-polska-ranking/", element: <KakobuySpreadsheetPolskaRanking /> },
  { path: "/artykul/lista-produktow-kakobuy/", element: <ListaProduktowKakobuy /> },
  { path: "/artykul/kakobuy-spreadsheet-linki/", element: <KakobuySpreadsheetLinki /> },
  { path: "/artykul/kakobuy-finds-polska/", element: <KakobuyFindsPolska /> },
  { path: "/artykul/kakobuy-sneakers-spreadsheet/", element: <KakobuySneakersSpreadsheet /> },
  { path: "/artykul/kakobuy-clothing-spreadsheet/", element: <KakobuyClothingSpreadsheet /> },
  { path: "/artykul/nowy-kakobuy-spreadsheet-2026/", element: <NowyKakobuySpreadsheet /> },
  { path: "/artykul/budget-spreadsheet-kakobuy/", element: <BudgetSpreadsheetKakobuy /> },
  { path: "/artykul/luxury-spreadsheet-kakobuy/", element: <LuxurySpreadsheetKakobuy /> },
  { path: "*", element: <NotFound /> },
];

export default routes;